import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	input: {
		maxHeight: 100,
		overflow: "auto !important"
	},
	inputDisabled: {
		opacity: 0.5,
		color: "transparent !important",
		cursor: ""
	}
})

export default useStyles
